import { render } from "./IconLXTerminals.vue?vue&type=template&id=1adb0df8"
import script from "./IconLXTerminals.vue?vue&type=script&lang=js"
export * from "./IconLXTerminals.vue?vue&type=script&lang=js"
script.render = render

export default script